// src/components/Admin/ManageEvents.jsx
import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function ManageEvents() {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    name: '',
    gender: 'Men',
    category_id: '',
    is_sport: false, // Add this field
  });

  useEffect(() => {
    fetchEvents();
    fetchCategories();
  }, []);
// Helper to check cultural team events
const isCulturalTeamEvent = (name = "") => {
  const keywords = [
    "Folkdance",
    "Contemporary Dance",
    "Streetdance",
    "Short and Sweet Play",
    "Radio Drama",
    "Cheerdance",
    "Live Band",
  ];
  return keywords.some(k => name.toLowerCase().includes(k.toLowerCase()));
};

  const fetchEvents = async () => {
    try {
      const res = await api.get('/events');
      setEvents(res.data);
    } catch (err) {
      alert('Failed to load events');
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await api.get('/categories');
      setCategories(res.data);
    } catch (err) {
      alert('Failed to load categories');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/events', form);
      setForm({ name: '', gender: 'Men', category_id: '', is_sport: false });
      fetchEvents();
    } catch (err) {
      alert('Failed to create event');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this event?')) return;
    try {
      await api.delete(`/events/${id}`);
      fetchEvents();
    } catch (err) {
      alert('Failed to delete');
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-6">Manage Events</h2>

      {/* Add Event */}
      <form onSubmit={handleSubmit} className="bg-gray-50 p-4 rounded mb-6 grid grid-cols-1 md:grid-cols-5 gap-3">
       <input
  type="text"
  placeholder="Event Name"
  value={form.name}
  onChange={(e) => {
    const name = e.target.value;
    setForm({
      ...form,
      name,
      is_sport: form.is_sport || isCulturalTeamEvent(name) // auto-set based on keywords
    });
  }}
  className="p-2 border rounded"
  required
/>

        <select
          value={form.gender}
          onChange={(e) => setForm({ ...form, gender: e.target.value })}
          className="p-2 border rounded"
        >
          <option value="Men">Men</option>
          <option value="Women">Women</option>
          <option value="Mixed">Mixed</option>
        </select>
        <select
          value={form.category_id}
          onChange={(e) => setForm({ ...form, category_id: e.target.value })}
          className="p-2 border rounded"
          required
        >
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={form.is_sport}
            onChange={(e) => setForm({ ...form, is_sport: e.target.checked })}
            className="mr-2"
          />
          Is Team Event?
        </label>
        <button type="submit" className="btn btn-primary">Add Event</button>
      </form>

      {/* List */}
      <div className="space-y-2">
        {events.map(ev => (
          <div key={ev.id} className="flex justify-between items-center p-3 bg-white border rounded">
            <span>
              {ev.name} ({ev.gender}) • <strong>{ev.category_name}</strong> • {ev.is_sport ? 'Sport' : 'Non-Sport'}
            </span>
            <button
              onClick={() => handleDelete(ev.id)}
              className="text-red-500 hover:text-red-700 text-sm"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}